import { map } from "lodash";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { database, storage } from "../../config/firebaseConfig";

const submitForm = async ({ values, dbPath, callback }) => {
  const dbKey = values.id || database.ref(dbPath).push().key;

  try {
    const urls = await Promise.all(
      map(values?.unsavedFiles, async (fileObject) => {
        const { name } = fileObject;
        const filePathKey = database.ref(`${dbPath}/${dbKey}/files`).push().key;
        const filePath = `${dbPath}/${dbKey}/${filePathKey}/${name}`;
        const storageRef = storage.ref(filePath);
        const downloadUrl = await storageRef
          .put(fileObject)
          .then(async (snapshot) => {
            const url = await snapshot.ref.getDownloadURL().then((dl) => dl);
            return url;
          })
          .catch((error) => {
            console.log("Error with upload", error);
          });
        return { filePath, downloadUrl, fileName: name };
      })
    );
    const id = values.id || dbKey;
    const newValues = {
      ...values,
      id,
      assetDateKey: `${values.asset}__${values.date}__${id}`,
      unsavedFiles: null,
      files: [...values.files, ...urls],
    };
    return database.ref(dbPath).child(dbKey).set(newValues).then(callback);
  } catch (error) {
    console.log("Form save error", error);
  }
};

export const submitFormValues = createAsyncThunk(
  "forms/submitForm",
  async (values, thunkAPI) => {
    try {
      const response = await submitForm(values);
      return response.data;
    } catch (e) {
      throw e;
    }
  }
);

export const fetchRebuildForms = () => async (dispatch) => {
  try {
    await database.ref("forms/rebuild/forms").on("value", (snapshot) => {
      dispatch(formsSuccess(snapshot.val() || {}));
    });
    return;
  } catch (e) {
    console.error(e);
  }
};

export const offRebuildForms = () => async () => {
  try {
    await database.ref("forms/rebuild/forms").off();
  } catch (e) {
    console.error(e);
  }
};

const slice = createSlice({
  name: "forms",
  initialState: {
    forms: {},
    status: "idle",
  },
  reducers: {
    formsSuccess: (state, action) => {
      state.forms = action.payload;
      state.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitFormValues.pending, (state) => {
        state.status = "loading";
      })
      .addCase(submitFormValues.fulfilled, (state) => {
        state.status = "idle";
      });
  },
});

export default slice.reducer;

const { formsSuccess } = slice.actions;

export const fetchForms = () => async (dispatch) => {
  try {
    await database.ref("forms/forms").on("value", (snapshot) => {
      dispatch(formsSuccess(snapshot.val()));
    });
    return;
  } catch (e) {
    return console.error(e);
  }
};
